import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { verifyMobileLogin } from "./../../api/api"; // 👈 use centralized API
import { Box, Typography, Button, Card, CardContent, Alert } from "@mui/material";

const VerifyAdmin = () => {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [userEmail, setUserEmail] = useState("");
  const [showBranchSelection, setShowBranchSelection] = useState(false);
  const [loading, setLoading] = useState(true);

  const selectBranch = (selectedBranch) => {
    console.log("Selected branch:", selectedBranch);
    
    // Store complete user info in localStorage (same as regular login)
    const userData = {
      id: selectedBranch.id,
      branch_id: selectedBranch.branch_id || selectedBranch.id,
      client_id: selectedBranch.client_id,
      branch_name: selectedBranch.branch_name,
      user_name: selectedBranch.user_name,
      email: selectedBranch.email,
      phone: selectedBranch.phone,
      logo: selectedBranch.logo
    };
    
    console.log("Storing user data:", userData);
    
    localStorage.setItem("token", selectedBranch.id);
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("branch_id", selectedBranch.branch_id || selectedBranch.id);
    localStorage.setItem("client_id", selectedBranch.client_id);
    localStorage.setItem("branch_name", selectedBranch.branch_name);

    // Verify the data was stored correctly
    console.log("Stored user data:", JSON.parse(localStorage.getItem("user")));
    console.log("Stored branch_name:", localStorage.getItem("branch_name"));

    // Redirect to dashboard
    setTimeout(() => {
      console.log("Navigating to dashboard...");
      window.location.href = "/home"; // More reliable redirect
    }, 300);
  };

  useEffect(() => {
    const verify = async () => {
      console.log("Verifying Mobile Login...");
      const queryParams = new URLSearchParams(window.location.search);
      const user = queryParams.get("user"); // Get mobile number or email from URL

      if (!user) {
        alert("Invalid login response.");
        navigate("/");
        return;
      }

      setUserEmail(user);

      try {
        const data = await verifyMobileLogin(user);

        if (data.status) {
          console.log("Login successful!");
          
          // Check if multiple branches are available
          if (data.multiple_branches && data.available_branches) {
            setBranches(data.available_branches);
            setShowBranchSelection(true);
            setLoading(false);
          } else {
            // Single branch - proceed with login
            localStorage.setItem("token", data.user.id);
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("branch_id", data.user.branch_id);
            localStorage.setItem("client_id", data.user.client_id);
            localStorage.setItem("branch_name", data.user.branch_name);

            // Redirect to dashboard
            setTimeout(() => {
              console.log("Navigating to dashboard...");
              window.location.href = "/home"; // More reliable redirect
            }, 300);
          }
        } else {
          alert(data.message);
          navigate("/");
        }
      } catch (error) {
        console.error("Error verifying mobile login:", error);
        alert("User not found. Please register.");
        navigate("/");
      }
    };

    verify();
  }, [navigate]);

  if (loading) {
    return <h2>Verifying Mobile Login...</h2>;
  }

  if (showBranchSelection) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        p: 3,
        bgcolor: '#f5f5f5'
      }}>
        <Card sx={{ maxWidth: 500, width: '100%' }}>
          <CardContent>
            <Typography variant="h5" gutterBottom align="center">
              Select Branch
            </Typography>
            <Alert severity="info" sx={{ mb: 3 }}>
              Multiple branches found for {userEmail}. Please select the branch you want to access.
            </Alert>
            {branches.map((branch) => (
              <Button
                key={branch.id}
                variant="outlined"
                fullWidth
                sx={{ mb: 2, p: 2 }}
                onClick={() => selectBranch(branch)}
              >
                <Box sx={{ textAlign: 'left', width: '100%' }}>
                  <Typography variant="h6">{branch.branch_name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Username: {branch.user_name}
                  </Typography>
                </Box>
              </Button>
            ))}
          </CardContent>
        </Card>
      </Box>
    );
  }

  return <h2>Verifying Mobile Login...</h2>;
};

export default VerifyAdmin;